import React, { useEffect, useState } from 'react';
import styled from '@emotion/styled';
import {
	BrandUtil,
	EmotionBreakpoint,
	usePageLayer,
	wineryDirectStates,
} from 'dw-us-ui';
import Ellipse from './images/Ellipse';

const Layout = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 70px;
	max-width: 100%;
`;

const MainContainer = styled.div`
	display: flex;
	justify-content: center;
	align-items: flex-start;
	gap: 66px;
`;
const BrothersCards = styled.div`
	display: flex;
	width: 100%;
	max-width: 360px;
	height: 100%;
	max-height: 100%;
	flex-direction: column;
	align-items: center;
	gap: 0px;
	a {
		color: ${(props) =>
			props.brosCardLinkColor ? props.brosCardLinkColor : '#fff'} !important;
		text-decoration: none;
	}
	${EmotionBreakpoint('mobile')} {
		display: flex;
		width: 186px;
		flex-direction: column;
		align-items: center;
		gap: 0px;
	}
	${EmotionBreakpoint('tablet')} {
		display: flex;
		width: 186px;
		flex-direction: column;
		align-items: center;
		gap: 0px;
	}
`;
const CardImage = styled.div`
	display: flex;
	img {
		width: 250px;
		height: 250px;
		flex-shrink: 0;
		border-radius: 50%;
		overflow: hidden;
		border: 2px solid
			${(props) =>
				props.imageBorderColor ? props.imageBorderColor : '#FFFFFF00'};
	}
	${EmotionBreakpoint('tablet')} {
		img {
			width: 182px;
			height: 182px;
			flex-shrink: 0;
		}
	}

	${EmotionBreakpoint('mobile')} {
		img {
			width: 182px;
			height: 182px;
			flex-shrink: 0;
		}
	}
`;
const CardNamePlate = styled.div`
	color: ${(props) => (props.cardColor ? props.cardColor : 'rgba(0, 0, 0, 0)')};
	border-radius: 40px;
	border: 2px solid
		${(props) => (props.cardColor ? props.cardColor : 'rgba(0, 0, 0, 0)')};
	background: ${(props) =>
		props.namePlatebackGroundColor
			? props.namePlatebackGroundColor
			: '#faf3e6'};
	display: inline-flex;
	padding: 5px 26px;
	align-items: center;
	gap: 10px;
	font-family: ${(props) =>
			props.brosCardFont ? props.brosCardFont : 'Open Sans'},
		sans-serif;
	font-size: 10px;
	font-style: normal;
	font-weight: 600;
	line-height: 12px;
	letter-spacing: 0.5px;
	text-transform: uppercase;
	margin-top: -10px;
	${EmotionBreakpoint('mobile')} {
		padding: 6px 11px 4px 11px;
	}
	${EmotionBreakpoint('tablet')} {
		padding: 6px 11px 4px 11px;
	}
`;
const CollectionHeadline = styled.div`
	margin-top: 30px;
	margin-bottom: 30px;
	img {
		max-width: 360px;
		width: 100%;
		max-height: 99px;
		height: 100%;
	}
	${EmotionBreakpoint('tablet')} {
		max-width: 200px;
		width: 100%;
		height: 88px;
		max-height: 100%;
	}
	${EmotionBreakpoint('mobile')} {
		margin-top: 34px;
		margin-bottom: 16px;
		img {
			max-width: 200px;
			width: 100%;
			max-height: 75px;
		}
	}
`;
const CardButton = styled.div`
	cursor: pointer;
	display: flex;
	width: 184px;
	padding: 15px 25px 14px 25px;
	justify-content: center;
	align-items: center;
	gap: 10px;
	text-align: center;
	font-family: ${(props) =>
			props.brosCardFont ? props.brosCardFont : 'Open Sans'},
		sans-serif;
	font-size: 12px;
	font-style: normal;
	font-weight: 600;
	line-height: 14px;
	letter-spacing: 0.75px;
	text-transform: uppercase;
	background: ${(props) =>
		props.cardColor ? props.cardColor : 'rgba(0, 0, 0, 0)'};
	a {
		color: ${(props) =>
			props.brosCardLinkColor ? props.brosCardLinkColor : '#fff'} !important;
		text-decoration: none;
	}
	${EmotionBreakpoint('mobile')} {
		display: flex;
		width: 185px;
		padding: 15px 25px 14px 25px;
		justify-content: center;
		align-items: center;
		gap: 10px;
		color: #fff;
		text-align: center;
		font-family: ${(props) =>
				props.brosCardFont ? props.brosCardFont : 'Open Sans'},
			sans-serif;
		font-size: 12px;
		font-style: normal;
		font-weight: 600;
		line-height: 14px;
		letter-spacing: 0.75px;
		text-transform: uppercase;
	}
	${EmotionBreakpoint('tablet')} {
		display: flex;
		width: 185px;
		padding: 15px 25px 14px 25px;
		justify-content: center;
		align-items: center;
		gap: 10px;
		color: #fff;
		text-align: center;
		font-family: ${(props) =>
				props.brosCardFont ? props.brosCardFont : 'Open Sans'},
			sans-serif;
		font-size: 12px;
		font-style: normal;
		font-weight: 600;
		line-height: 14px;
		letter-spacing: 0.75px;
		text-transform: uppercase;
	}
`;
const CallToAction = styled.div`
	cursor: pointer;
	color: ${(props) =>
		props.brosCardCtaTextColor ? props.brosCardCtaTextColor : '#00193c'};
	text-align: center;
	font-family: ${(props) =>
			props.brosCardFont ? props.brosCardFont : 'Open Sans'},
		sans-serif;
	font-size: 14px;
	font-style: normal;
	font-weight: 400;
	line-height: 18.2px;
	padding-top: 16px;
	text-decoration: underline;
	${EmotionBreakpoint('mobile')} {
		padding-top: 14px;
	}
`;

const ThreeBrothersCards = ({ card, contentfulData }) => {
	const pageLayer = usePageLayer();

	return (
		<Layout>
			<MainContainer>
				<BrothersCards>
					<Ellipse
						text={card.fields?.ellipse}
						cardColor={card?.fields.cardColor}
					/>
					<CardImage
						cardColor={card?.fields?.cardColor}
						imageBorderColor={card?.fields?.imageBorderColor}
					>
						<img src={card.fields?.cardImage?.fields?.file?.url} />
					</CardImage>
					{card.fields?.namePlate?.content[0]?.content[0]?.value && (
						<CardNamePlate
							cardColor={card?.fields?.cardColor}
							namePlatebackGroundColor={
								contentfulData?.namePlatebackGroundColor
							}
							brosCardFont={contentfulData?.brosCardFont}
						>
							{card.fields?.namePlate?.content[0]?.content[0]?.value}
						</CardNamePlate>
					)}
					<CollectionHeadline>
						<img
							src={card?.fields?.subscriptionOverviewImage?.fields?.file?.url}
						/>
					</CollectionHeadline>
					<a
						href={
							wineryDirectStates.includes(pageLayer?.stateCode)
								? card?.fields?.wineryDirectLink
								: card?.fields?.threeTierLink
						}
						brosCardLinkColor={contentfulData?.brosCardLinkColor}
					>
						<CardButton
							role='button'
							cardColor={card?.fields?.cardColor}
							brosCardFont={contentfulData?.brosCardFont}
						>
							{card?.fields?.buttonCopy}
						</CardButton>
					</a>
					<CallToAction
						brosCardCtaTextColor={contentfulData?.brosCardCtaTextColor}
						brosCardFont={contentfulData?.brosCardFont}
						role='button'
						onClick={() => {
							const targetElement =
								document.getElementById('BrothersCollection');
							if (targetElement) {
								targetElement.scrollIntoView({
									behavior: 'smooth',
								});
							}
						}}
					>
						{card?.fields?.callToAction}
					</CallToAction>
				</BrothersCards>
			</MainContainer>
		</Layout>
	);
};
export default ThreeBrothersCards;
